import { PosCampanhaAba11Service } from './../../../service/posCampanhaAba11/pos-campanha-aba11.service';
import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PartConselhoPosRecadDTO } from './partConselhoPosRecad.dto';
import { ThemePalette } from '@angular/material/core';
import { ServidorRecad } from 'app/model/servidorRecad';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from 'app/components/modal/modal.component';
import { Observable } from 'rxjs';
import { DocumentosPosRecadDto } from '../aba4-posrecad/documentosPosRecad.dto';

type DadosTabela = {
  descricao: string;
  informacaoSrh: string;
  informacaoRecad: string;
  anexo: string;
}


@Component({
  selector: 'app-aba11-posrecad',
  templateUrl: './aba11-posrecad.component.html',
  styleUrls: ['./aba11-posrecad.component.sass']
})

export class Aba11PosrecadComponent implements OnInit {

  @Input() servidor: ServidorRecad;
  @Output() flExibirTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() salvoOutput: EventEmitter<any> = new EventEmitter<any>();
  @Output() botoesDesabilitadosConselhos: EventEmitter<any> = new EventEmitter<any>();
  @Input() btnDesativadoConselhos: boolean;

  displayedColumns: string[] = ['descricao', 'informacaoSrh', 'informacaoRecad'];
  color: ThemePalette = 'primary';
  list: DadosTabela[] = [];

  dataSource: MatTableDataSource<DadosTabela> = new MatTableDataSource<DadosTabela>([]);
  partConselhoPosRecad: PartConselhoPosRecadDTO;
  salvo: boolean = false;
  panelOpenState = false;
  documentos: PartConselhoPosRecadDTO;
  justificativa: string = '';
  isDisabledJustificativa: boolean = true
  possuiAlteracaoConselho: boolean;


  constructor(private toasterService: ToastrService, public dialog: MatDialog, private posCampanhaAba11Service: PosCampanhaAba11Service) { }

  ngOnInit(): void {
    // this.processarConselhos(this.servidor.id);
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes.servidor && changes.servidor.currentValue) {
    //   this.dataSource.data = [];
    //   this.list = [];
    //   this.salvo = false;
    //   this.justificativa = "";
    //   this.processarConselhos(this.servidor.id);
    // }
      this.dataSource.data = [];
      this.list = [];
      this.salvo = false;
      // this.justificativa = "";
      this.processarConselhos(this.servidor.id);
  }


  private getObterConselhos(recadServidorId: number): Observable<PartConselhoPosRecadDTO> {
    return this.posCampanhaAba11Service.getObterConselhos(recadServidorId);  
  }

  processarConselhos(validacaoRecadId: number) {
    this.getObterConselhos(validacaoRecadId).subscribe(
      response => {
        this.partConselhoPosRecad = response
        if (response) {
          // this.contatos = response;
          this.dataSource.data = this.montarDadosTabela(response);
        } else {
          this.flExibirTab.emit(false);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private montarDadosTabela(resp: PartConselhoPosRecadDTO): DadosTabela[] {
    this.list.push(

      { descricao: "Nome do Conselho ou Assemelhado", informacaoSrh: resp.nomeParticipacaoSrh, anexo: "anexo-conselho", informacaoRecad: resp.nomeParticipacaoRecad },
      { descricao: "Órgão ou Instituição que o agrupamento é vinculado", informacaoSrh: resp.nomeOrgaoVinculadoSrh, anexo: "anexo-conselho", informacaoRecad: resp.nomeOrgaoVinculadoRecad },
      { descricao: "Mandato: Data Início", informacaoSrh: resp.dataInicioSrh, anexo: "anexo-conselho", informacaoRecad: resp.dataInicioRecad},
      { descricao: "Mandato: Data Fim", informacaoSrh: resp.dataFimSrh, anexo: "anexo-conselho", informacaoRecad: resp.dataFimRecad },
      { descricao: "Origem", informacaoSrh: resp.origemSrh, anexo: "anexo-conselho", informacaoRecad: resp.origemRecad },
      { descricao: "Tipo de Participação", informacaoSrh: resp.tipoParticipacaoSrh, anexo: "anexo-conselho", informacaoRecad: resp.tipoParticipacaoRecad },
      { descricao: "Função", informacaoSrh: resp.funcaoSrh, anexo: "anexo-conselho", informacaoRecad: resp.funcaoRecad },
      { descricao: "Forma de Participação", informacaoSrh: resp.formaParticipacaoSrh, anexo: "anexo-conselho", informacaoRecad: resp.formaParticipacaoRecad },
      { descricao: "Lei / Norma / Ato de Criação", informacaoSrh: resp.leiSrh, anexo: "anexo-conselho", informacaoRecad: resp.leiRecad },

    );
    return this.list;
  }


  visualizarComprovante(comprovante: string) { 
    console.log(comprovante)
    this.getVisualizarComprovante(this.partConselhoPosRecad.recadValidacaoConselhoId, comprovante).subscribe(
      response => {
        const blobUrl = URL.createObjectURL(response);

        // Especifica as dimensões da nova janela (largura x altura)
        const newWindow = window.open(blobUrl, '_blank', 'width=800,height=800');

        // Verifica se a janela foi aberta com sucesso
        if (newWindow) {
          newWindow.focus();
        } else {
          this.toasterService.warning('Erro ao abrir a nova janela.', '', {
            timeOut: 1500
          });
        }
      },
      error => {
        this.toasterService.warning('Erro ao visualizar o arquivo', '', {
          timeOut: 1500
        });
       
      }
    );

  }

  getVisualizarComprovante(recadValidacaoConselhoId: number, comprovante: string): Observable<any> {
    return this.posCampanhaAba11Service.getObterArquivos(recadValidacaoConselhoId, comprovante);
  }

  openDialog(): void {
    this.dialog.open(ModalComponent, {
      width: '450px',
      data: {
        header: 'Justificativa',
        descricao: 'Justifique o motivo de recusa:',
        labelOne: 'Cancelar',
        labelTwo: 'Salvar',
        flTextArea: true,
        action: (justificativa: string) => {
          this.justificativa = justificativa;
          this.aprovar(3)
          this.botoesDesabilitadosConselhos.emit(true);

        }
      }
    });
  }

  rejeitar(){
    this.isDisabledJustificativa = false
    this.openDialog();
  }

  aprovar(status){
    /*
    status
    1- aceito
    2-pendente
    3- recusado
    * */
    this.botoesDesabilitadosConselhos.emit(true);
    if(status == 1){
      this.justificativa = ''
    }
    let body = {
      id: this.servidor.id,
      status: status,
      justificativa: this.justificativa,
     
    }
    this.posCampanhaAba11Service.postConselhos(body).subscribe( resp => {
      this.toasterService.success("Dados salvos com sucesso");
      this.salvo = true;
      this.salvoOutput.emit(true);
    },
    (error) => {
      this.toasterService.error('Erro ao salvar os dados.', '', {
        timeOut: 1500
      })
      this.toasterService.success("Dados salvos com sucesso");
      this.salvo = true;
      this.salvoOutput.emit(true);
    });
  }


}
